module.exports = __webpack_public_path__ + "static/media/smartphone-payment-touch.ea128bfe.svg";